import { FormControl, FormLabel, Select } from "@chakra-ui/react";

export default function SelectInput({
  required,
  name,
  value,
  onChange,
  placeholder,
  options,
  optionKey,
  optionValue,
  optionLabel,
  children,
}) {
  return (
    <FormControl isRequired={required}>
      <FormLabel htmlFor={name}>{children}</FormLabel>
      <Select id={name} name={name} value={value} onChange={onChange}>
        <option value="" disabled>
          {placeholder}
        </option>
        {options &&
          options.map((option) => (
            <option key={optionKey(option)} value={optionValue(option)}>
              {optionLabel(option)}
            </option>
          ))}
      </Select>
    </FormControl>
  );
}
